import { render, staticRenderFns } from "./MoveVideo.vue?vue&type=template&id=3315fd2d&scoped=true"
import script from "./MoveVideo.vue?vue&type=script&lang=js"
export * from "./MoveVideo.vue?vue&type=script&lang=js"
import style0 from "./MoveVideo.vue?vue&type=style&index=0&id=3315fd2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315fd2d",
  null
  
)

export default component.exports